<!-- <div class="w-full h-full fixed top-0 left-0 z-50 bg-black bg-opacity-10 backdrop-blur-sm">
    <div class="flex justify-center items-center mt-[45vh]">
      <div className="grid grid-cols-1 grid-rows-2 gap-2">
          <div class="text-center">
            <div class="h-24 w-32 bg-no-repeat bg-cover bg-logo-light dark:bg-logo-dark"></div>
          </div>
          <div class="text-center">
            <p-progressSpinner
            styleClass="w-8 h-8"
            strokeWidth="8"
            animationDuration="1s" />
          </div>
      </div>
      <br>
    </div>
  </div> -->

<div class="flex h-screen items-center justify-center">
  <div class="m-auto transition duration-150 ease-in-out">
    <img class="h-[10rem] w-[10rem]" src="assets/images/TOLIS_Loader.gif" alt="" srcset="" />
  </div>
</div>
